<ifr-page-title pageTitle="'LEFT_PANEL_WEEKLY_SCHEDULE' | translate "/>
<div
  id="wid-plan-content-0"
>
  <weekly-calendar
    type="6040"
    api-url="'/WebPlanningAPI'"
    auth-token="authToken"
    locale="locale"
    user-id="userId"
    theme="theme"
    licenses="licenses"
    on-auth-error="onAuthError"
    simple-user-id="simpleUserId"
    personnelNumberEnabled="personnelNumberEnabled"
    selectedPerson="selectedPerson"
    onSelectedPersonChange="onSelectedPersonChange"
    openedFromTimeManagement="true"
  ></weekly-calendar>
</div>
